<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item "><router-link :to="getHomePath()">Home</router-link></li>
        <li v-if="userIsAdmin" class="breadcrumb-item "><router-link :to="getEditMenuPath(menu.id)">Edici&oacute;n de menú web</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">Listado de elementos del menú</li>
      </ol>
    </nav>
    <draf-message @draft_resolved="initMenu()" :menu="menu" />
    <div class="container-fluid">
      <div v-if="successMessage" class="alert alert-success" role="alert">
        {{ successMessage }}
      </div>
      <div v-if="errorMessages.length" class="alert alert-danger" role="alert">
        <p v-for="message in errorMessages">{{ message }}</p>
      </div>
      <h2 class="text-center">Listado de elementos del menú '{{ menu.name }}'</h2>
      <div v-if="menu.items && menu.items.length > 4" class="text-center text-center layer-button">
        <router-link :to="getAddMenuItemPath(menu.id)">
          <button v-if="userIsAdmin && !waiting" class="btn btn-primary">Crear nuevo elemento del menú</button>
        </router-link>
      </div>
      <menus-items-table
              :menu="menu"
              :environment="environment"
              @delete_menu_item="onDeleteItemMenu"
              @move="onMoveMenuItem"
      />
      <div class="text-center text-center layer-button">
        <router-link :to="getAddMenuItemPath(menu.id)">
          <button v-if="userIsAdmin && !waiting" class="btn btn-primary">Crear nuevo elemento del menú</button>
        </router-link>
      </div>
      <div v-if="menu.items && menu.items.length > 0" class="text-center text-center layer-button" style="margin-top: 40px;">
        <button type="button" @click="duplicateMenuItem" class="btn btn-primary" :disabled='waiting'>
          <span v-if="waiting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Duplicar elemento del menú existente
        </button>
        &nbsp;
        <select id="item_to_duplicate">
          <option :value="item.id" v-for="item in menu.items">{{ item.name }}</option>
        </select>
      </div>
    </div>
    <div v-if="waiting" class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <confirm-delete-menu-item
            :visible="showModalFlag"
            @close_delete_menu_item="onModalClose"
            @confirm_delete_menu_item="onModalConfirmed"
    />
    <div v-if="isDevServer"><pre>{{ menu }}</pre></div>
  </div>
</template>

<script>
import axios from 'axios';
import BaseMenuView from '@/views/BaseMenuView.vue'
import MenusItemsTable from '@/components/Tables/MenusItemsTable.vue'
import ConfirmDeleteMenuItem from '@/components/Modals/ConfirmDeleteMenuItem.vue'
import DrafMessage from '@/components/DrafMessage.vue'

export default {
  name: 'list-menu-items',
  extends: BaseMenuView,
  components: {
    'menus-items-table' : MenusItemsTable,
    'confirm-delete-menu-item' : ConfirmDeleteMenuItem,
    'draf-message' : DrafMessage,
  },
  data () {
    return {
      showModalFlag : false,
      itemIdToDelete : null,
    };
  },
  methods: {
    duplicateMenuItem () {
      const itemId = document.getElementById("item_to_duplicate").value;
        axios
          .put(this.getDuplicateMenuItemUrl(), { data: {id : itemId} })
          .then(response => {
            if (response.data.result) {
              this.setSuccessMessage('Se ha duplicado el elemento de menú correctamente.');
            } else {
              this.addErrorMessage('Se ha producido un error al duplicar el elemento de menú.');
            }
          }).catch(() => {
            this.addErrorMessage('Se ha producido un error al duplicar el elemento de menú.');
          }).finally (() => {
            this.initMenu();
          });
    },
    deleteMenuItem () {
      axios
        .delete(this.getMenuItemUrl(), { data: {id : this.itemIdToDelete} })
        .then(response => {
          if (response.data.result) {
            this.setSuccessMessage('Se ha eliminado el elemento de menú correctamente.');
          } else {
            this.addErrorMessage ('Se ha producido un error al eliminar el elemento de menú.');
          }
        }).catch(() => {
          this.addErrorMessage ('Se ha producido un error al eliminar el elemento de menú.');
        }).finally (() => {
          this.initMenu();
        });
    },
    onDeleteItemMenu (itemId) {
      this.itemIdToDelete = itemId;
      this.showModal ();
    },
    onModalClose () {
      this.hideModal ();
      this.itemIdToDelete = null;
    },
    onModalConfirmed () {
      this.hideModal ();
      this.deleteMenuItem();
      this.itemIdToDelete = null;
    },
    hideModal () {
      this.showModalFlag = false;
    },
    showModal () {
      this.showModalFlag = true;
    },
    setSuccessMessage (message) {
      this.successMessage = message;
      this.errorMessages = [];
    },
    addErrorMessage (message) {
      this.successMessage = "";
      this.errorMessages.push(message);
    },
    onMoveMenuItem (move) {
      this.waiting = true;
      let data = {
        'menu_id' : this.menu.id,
        'from_position' : (move['from'] + 1),
        'to_position' : (move['to'] + 1)
      };
      axios
        .put(this.getMenuItemsPositionUrl(), data)
        .then(response => {
          if (response.data.result) {
            this.setSuccessMessage('Orden de los elementos actualizado correctamente');
          } else {
            this.addErrorMessage ('Se ha producido un error al modificar el orden de los elementos.');
          }
        }).catch(() => {
          this.addErrorMessage ('Se ha producido un error al modificar el orden de los elementos.');

        }).finally(() => {
          this.waiting = false;
          this.initMenu();
        });
    },
  }
}
</script>
